import React from 'react';
import {Card, CardActions, CardContent, CardMedia, makeStyles, Typography} from "@material-ui/core";
import BonusMoneyRulesStrapline from "Components/BonusMoneyRulesStrapline";
import {SecondaryButton} from "Components/Button";
import useModal from "Hooks/useModal";
import {convertImagePathToWebpPath} from "Helpers/images";

export const useRewardsCardStyles = makeStyles(theme => {
    const RewardsPageSettings = theme.overrides.RewardsPage;
    return {
        root: {
            display: "flex",
            flexDirection: "column",
            margin: theme.spacing(0, 1.5, 3),
            maxWidth: 450,
            border: 'none',
            background: RewardsPageSettings.cards.background,
            borderRadius: RewardsPageSettings.borderRadius,
            boxShadow: "0 -1px 1px 0 rgba(0, 0, 0, .05), 0 1px 3px 0 rgba(0, 0, 0, .2)",
            color: RewardsPageSettings.cards.textColor,
            backdropFilter: 'blur(12px)',

            '& .MuiTypography-caption': {
                fontSize: '11px'
            },
            '& .MuiCardContent-root': {
                // minHeight: 145
            },
            '& .MuiTypography-body2': {
                fontWeight: 200
            },
        },
        actions: {
            justifyContent: "center",
            marginTop: "auto",
            marginBottom: theme.spacing(1)
        },
        action: {
            width: 184
        },
        strapline: {
            background: RewardsPageSettings.strapline.background,
            color: RewardsPageSettings.strapline.textColor,
            opacity: 0.7,
            fontWeight: 200,
            lineHeight: 'inherit',
            padding: theme.spacing(1, 0),
        },
        media: {
            height: 175,
        }
    }
});

export const RewardsCard = (props) => {
    const {title, desc, image, promoId} = props;
    const classes = useRewardsCardStyles();
    const {openModal} = useModal();

    const imagePath = convertImagePathToWebpPath(image);

    return (
        <Card className={classes.root} elevation={3}>
            <CardMedia
                className={classes.media}
                image={imagePath}
            />
            <CardContent>
                <Typography gutterBottom variant="h5" component="h4">
                    {title}
                </Typography>
                <Typography variant="body2" component="p">
                    {desc}
                </Typography>
            </CardContent>
            <CardActions className={classes.actions}>
                <SecondaryButton className={classes.action} onClick={() => openModal('Promotion', {promoId, isRewardsModal: true})}>Read More</SecondaryButton>
                {/*<PrimaryButton onClick={() => console.log('Promotion', {promoId: props.promoId})}>Read More</PrimaryButton>*/}
            </CardActions>
            <BonusMoneyRulesStrapline className={classes.strapline} transparent/>
        </Card>
    );
}
